var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvBgImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 142,
    viewBox: "0 0 282 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2324 2.93793C33.2324 1.31536 34.4129 0 35.8689 0H246.131C247.587 0 248.768 1.31536 248.768 2.93793V5.87586H33.2324V2.93793Z",
    fill: "#0B0B0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0063 135.145H33.2324V140.629C33.2324 141.386 33.8223 142 34.5507 142H51.688C52.4164 142 53.0063 141.386 53.0063 140.629V135.145ZM248.768 135.145H228.994V140.629C228.994 141.386 229.584 142 230.312 142H247.45C248.178 142 248.768 141.386 248.768 140.629V135.145Z",
    fill: "#131313"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.187 4.76953H19.8126C8.87042 4.76953 0 13.9185 0 25.2043V117.161C0 128.447 8.87042 137.596 19.8126 137.596H262.187C273.13 137.596 282 128.447 282 117.161V25.2043C282 13.9185 273.13 4.76953 262.187 4.76953Z",
    fill: "#2A2C32"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.216 13.7109H22.7848C14.9209 13.7109 8.5459 20.2199 8.5459 28.249V112.773C8.5459 120.802 14.9209 127.311 22.7848 127.311H259.216C267.08 127.311 273.455 120.802 273.455 112.773V28.249C273.455 20.2199 267.08 13.7109 259.216 13.7109Z",
    fill: "#010103"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.216 14H22.7848C14.9209 14 8.5459 20.5089 8.5459 28.5381V113.062C8.5459 121.091 14.9209 127.6 22.7848 127.6H259.216C267.08 127.6 273.455 121.091 273.455 113.062V28.5381C273.455 20.5089 267.08 14 259.216 14Z",
    fill: "url(#paint0_linear_1_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.216 13.7109H22.7848C14.9209 13.7109 8.5459 20.2199 8.5459 28.249V112.773C8.5459 120.802 14.9209 127.311 22.7848 127.311H259.216C267.08 127.311 273.455 120.802 273.455 112.773V28.249C273.455 20.2199 267.08 13.7109 259.216 13.7109Z",
    stroke: "black",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_i_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1147 14.3066C15.8199 14.3066 9.90625 20.4059 9.90625 27.9298V30.6545C9.90625 23.1306 15.8199 17.0313 23.1147 17.0313H258.885C266.18 17.0313 272.094 23.1306 272.094 30.6545V27.9298C272.094 20.4059 266.18 14.3066 258.885 14.3066H23.1147Z",
    fill: "url(#paint1_linear_1_4)",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_i_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.885 126.697C266.18 126.697 272.094 120.598 272.094 113.074V110.35C272.094 117.874 266.18 123.973 258.885 123.973H23.1147C15.8199 123.973 9.90625 117.874 9.90625 110.35V113.074C9.90625 120.598 15.8199 126.697 23.1147 126.697H258.885Z",
    fill: "url(#paint2_linear_1_4)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1_4",
    x: 0,
    y: 0.769531,
    width: 282,
    height: 140.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_4",
    result: "effect2_innerShadow_1_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_4",
    x: 9.90625,
    y: 14.3066,
    width: 263.187,
    height: 16.3478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_4",
    x: 9.90625,
    y: 110.35,
    width: 263.187,
    height: 16.3478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: 9.53931,
    y1: 15.0143,
    x2: 274.049,
    y2: 122.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4",
    x1: 141.33,
    y1: 14.3066,
    x2: 141.33,
    y2: 22.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4",
    x1: 140.67,
    y1: 126.697,
    x2: 140.67,
    y2: 118.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvBgImg);
export default __webpack_public_path__ + "static/media/tvBgImg.2c57be27a4c7e0e7a7ed3b9694ec314c.svg";
export { ForwardRef as ReactComponent };